// extracted by mini-css-extract-plugin
module.exports = {"content":"page-module--content--1RNGs","contentWithRightImage":"page-module--contentWithRightImage--2qfcu"};